import { render, staticRenderFns } from "./RelAgendaContagem.vue?vue&type=template&id=12913744"
import script from "./RelAgendaContagem.vue?vue&type=script&lang=js"
export * from "./RelAgendaContagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports